import React from "react";

import { ReactComponent as ModalCloseIcon } from "@/components/common/icons/modal-close.svg";
import { cn } from "@/utils/cn";

interface ModalCloseButtonProps {
  handleClose: () => void;
  positionClass?: string;
  className?: string;
}

/**
 * Close button component for modals using the Figma-designed X icon
 * Positioned absolutely, 12px from top & right by default
 */
const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({
  handleClose,
  positionClass = "absolute top-3 right-3",
  className,
}) => {
  return (
    <button
      className={cn(
        positionClass,
        "cursor-pointer flex items-center justify-center",
        className
      )}
      onClick={handleClose}
      aria-label="Close modal"
    >
      <ModalCloseIcon className="w-[15px] h-[15px]" />
    </button>
  );
};

export default ModalCloseButton;
